import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiSearch, FiBell, FiPlus, FiX, FiCheckCircle } from 'react-icons/fi';

export default function TopBar({ title }) {
  const [showModal, setShowModal] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  return (
    <header className="h-20 border-b border-[#1a1a1a] bg-[#0a0a0a]/50 backdrop-blur-md flex items-center justify-between px-8 sticky top-0 z-50 w-full">
      <h2 className="text-2xl font-light tracking-wide text-white">{title}</h2>
      
      <div className="flex items-center gap-6">
        <div className="relative hidden md:block">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
          <input 
            type="text" 
            placeholder="Search campaigns, assets..." 
            className="bg-[#141414] border border-[#2a2a2a] rounded-full py-2 pl-10 pr-4 text-sm text-white focus:outline-none focus:border-[#FF5A5F] w-64 transition-colors" 
          />
        </div>

        <div className="relative">
          <button 
            onClick={() => setNotificationsOpen(!notificationsOpen)}
            className={`relative p-2 transition-colors ${notificationsOpen ? 'text-[#FF5A5F]' : 'text-gray-400 hover:text-white'}`}
          >
            <SafeIcon icon={FiBell} className="text-xl" />
            <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-[#FF5A5F] shadow-[0_0_8px_rgba(255,90,95,0.8)]"></span>
          </button>

          <AnimatePresence>
            {notificationsOpen && (
              <motion.div 
                initial={{ opacity: 0, y: 10, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 10, scale: 0.95 }}
                className="absolute right-0 mt-4 w-72 glass-panel border-[#1a1a1a] p-4 shadow-2xl"
              >
                <div className="flex justify-between items-center mb-4 border-b border-[#1a1a1a] pb-2">
                  <span className="text-xs font-bold uppercase tracking-widest text-[#FF5A5F]">Alerts</span>
                  <button onClick={() => setNotificationsOpen(false)}><SafeIcon icon={FiX} className="text-gray-500 hover:text-white" /></button>
                </div>
                <div className="space-y-4">
                  <div className="flex gap-3">
                    <div className="w-2 h-2 rounded-full bg-[#FF5A5F] mt-1.5 shrink-0" />
                    <p className="text-xs text-gray-300"><span className="text-white font-medium">Elena</span> requested review on <span className="text-white">Q3 Video</span></p>
                  </div>
                  <div className="flex gap-3">
                    <div className="w-2 h-2 rounded-full bg-[#FF5A5F] mt-1.5 shrink-0" />
                    <p className="text-xs text-gray-300"><span className="text-white font-medium">System</span> successfully synced 12 assets</p>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <button 
          onClick={() => setShowModal(true)}
          className="btn-primary flex items-center gap-2 group"
        >
          <SafeIcon icon={FiPlus} className="group-hover:rotate-90 transition-transform" />
          <span>New Campaign</span>
        </button>
      </div>

      {/* New Campaign Modal Backdrop */}
      <AnimatePresence>
        {showModal && (
          <>
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowModal(false)}
              className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100]"
            />
            <motion.div 
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md glass-panel p-8 z-[101] border-[#2a2a2a]"
            >
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold text-white">Create Campaign</h3>
                <button onClick={() => setShowModal(false)} className="text-gray-500 hover:text-white"><SafeIcon icon={FiX} /></button>
              </div>
              <div className="space-y-4">
                <div>
                  <label className="text-xs text-gray-500 uppercase font-bold tracking-wider mb-2 block">Campaign Title</label>
                  <input type="text" placeholder="e.g. Summer Launch 2024" className="w-full bg-[#141414] border border-[#2a2a2a] rounded-lg px-4 py-2 text-white focus:border-[#FF5A5F] focus:outline-none" />
                </div>
                <div>
                  <label className="text-xs text-gray-500 uppercase font-bold tracking-wider mb-2 block">Primary Channel</label>
                  <select className="w-full bg-[#141414] border border-[#2a2a2a] rounded-lg px-4 py-2 text-white focus:border-[#FF5A5F] focus:outline-none">
                    <option>Instagram</option>
                    <option>LinkedIn</option>
                    <option>Twitter</option>
                  </select>
                </div>
                <button 
                  onClick={() => setShowModal(false)}
                  className="w-full btn-primary py-3 mt-4"
                >
                  Initialize Orbit
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </header>
  );
}